import "../sass/project.scss";
import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import { getFileDownloadLink, getDjangoDataFromJson } from "./utilities";
import { ChartApp, PageTypeContext } from "./ChartApp";
import { JmiJmoApp } from "./JmiJmoApp";
import { EnvironmentalTablesApp } from "./EnvironmentalTablesApp";
import { NewsApp } from "./NewsApp";
import { MyRepository } from "./myrepository/App";
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";
function renderReactApp() {
    const root = document.getElementById("root-react");
    if (root) {
        const datasetPageType = root.dataset.pageType;
        let pageType = datasetPageType || "environmental_indicators_data";
        if (pageType == "news") {
            const publicFiles = getDjangoDataFromJson("public_files");
            const types = getDjangoDataFromJson("types");
            const extensions = getDjangoDataFromJson("extensions");
            ReactDOM.createRoot(root).render(React.createElement(NewsApp, { publicFiles: publicFiles, types: types, extensions: extensions }));
        }
        else if (pageType == "my_repository") {
            const publicFiles = getDjangoDataFromJson("public_files");
            const privateFiles = getDjangoDataFromJson("private_files");
            const sharedToMe = getDjangoDataFromJson("shared_to_me");
            const sharedFiles = getDjangoDataFromJson("shared_files");
            const types = getDjangoDataFromJson("types");
            const extensions = getDjangoDataFromJson("extensions");
            ReactDOM.createRoot(root).render(React.createElement(MyRepository, { publicFiles: publicFiles, privateFiles: privateFiles, sharedToMe: sharedToMe, sharedFiles: sharedFiles, types: types, extensions: extensions }));
        }
        else if (pageType == "economic_jmi_data" || pageType == "economic_jmo_data") {
            const fileDownloadLink = getFileDownloadLink();
            const mainPageData = getDjangoDataFromJson("main_page_data");
            const checkboxesRaw = getDjangoDataFromJson("checkboxes_data");
            ReactDOM.createRoot(root).render(React.createElement(JmiJmoApp, { pageType: pageType, mainPageData: mainPageData, fileDownloadLink: fileDownloadLink, checkboxesRaw: checkboxesRaw }));
        }
        else if (pageType == "environmental_indicators_data") {
            const fileDownloadLink = getFileDownloadLink();
            const checkboxData = getDjangoDataFromJson("checkboxes_data");
            const tables = getDjangoDataFromJson("main_page_data");
            ReactDOM.createRoot(root).render(React.createElement(EnvironmentalTablesApp, { tables: tables, fileDownloadLink: fileDownloadLink, checkboxData: checkboxData }));
        }
        else {
            const fileDownloadLink = getFileDownloadLink();
            const mainPageData = getDjangoDataFromJson("main_page_data");
            ReactDOM.createRoot(root).render(React.createElement(PageTypeContext.Provider, { value: pageType },
                React.createElement(ChartApp, { pageType: pageType, mainPageData: mainPageData, fileDownloadLink: fileDownloadLink })));
        }
    }
}
renderReactApp();
